__turbopack_context__.v({
  "active": "L-mr4q_active",
  "container": "L-mr4q_container",
  "item": "L-mr4q_item",
  "placeholder": "L-mr4q_placeholder",
  "scroll-container": "L-mr4q_scroll-container",
});
